import React from 'react';
import { useLanguage } from '@/providers/LanguageProvider';
import { useShopStyle } from '@/providers/StyleOverwrites';

export const LanguageSelect: React.FC = () => {
    const { currentLanguage, changeLanguage, supportedLanguages } = useLanguage();
    const shopStyle = useShopStyle();

    // Fallback for old shops or if supportedLanguages is not available
    const fallbackLanguages = [
        { code: 'en', flagIcon: '🇬🇧' },
        { code: 'nl', flagIcon: '🇳🇱' },
    ];
    const languages = supportedLanguages && supportedLanguages.length > 0 ? supportedLanguages : fallbackLanguages;

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        changeLanguage(event.target.value);
    };

    return (
        <div className="relative">
            <select
                value={currentLanguage}
                onChange={handleChange}
                className="opacity-80 inline-flex items-center focus:shadow-[0_0_0_1px] outline-none px-2 py-1 pr-8 rounded border-none"
                 style={{ backgroundColor: shopStyle.panelBackgroundColor, color: shopStyle.textColor }}
                aria-label="Language"
            >
                {languages.map((language) => (
                    <option key={language.code} value={language.code}>
                        {language.flagIcon}
                    </option>
                ))}
            </select>
        </div>
    );
};
